<template>
  <transition name="reg-fade"
              mode="out-in">
    <router-view />
  </transition>
</template>

<script>
import { enforceProjectData } from './routes'
export default {
  name: 'RegProject',
  beforeRouteUpdate(to, from, next) {
    enforceProjectData(to.params.project).then(() => {
      next()
    }).catch(() => {
      next('/')
    })
  }
}
</script>
